export default function ForkRepo() {
  return (
    <div
      className="ion-icon-fork-repo"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<g>
	<polygon class="st0" points="416,80 368,80 368,32 304,32 304,80 256,80 256,144 304,144 304,192 368,192 368,144 416,144 	"/>
	<path class="st0" d="M304,240c0,38.6-4.5,42.3-14.4,50.3c-7.4,6-22.2,7.1-39.4,8.3c-9.5,0.7-20.4,1.5-31.4,3.3
		c-9.4,1.5-18.4,4.7-26.8,8.8V151.4c19.1-11.1,32-31.7,32-55.4c0-35.3-28.7-64-64-64S96,60.7,96,96c0,23.7,12.9,44.3,32,55.4v209.2
		c-19.1,11.1-32,31.7-32,55.4c0,35.3,28.7,64,64,64s64-28.7,64-64c0-15.7-5.7-30.1-15-41.2c6.7-4.8,13.9-8.7,20.2-9.7
		c8.1-1.3,16.6-1.9,25.6-2.6c24.4-1.7,52.1-3.7,75.2-22.5c30.9-25.1,37.5-52.1,38-94.9l0,0V240H304z M160,64c17.6,0,32,14.4,32,32
		s-14.4,32-32,32s-32-14.4-32-32S142.4,64,160,64z M160,448c-17.6,0-32-14.4-32-32s14.4-32,32-32s32,14.4,32,32S177.6,448,160,448z"
		/>
</g>
</svg>
`,
      }}
    />
  )
}
